<template>
    <!-- 收货地址页面 -->
    <div class="address_wrap">
        <!-- 顶部导航栏 -->
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">收货地址</div>
            <div class="add_btn" @click="showForm = true; resetForm()">
                <van-icon name="plus" />
            </div>
        </div>

        <!-- 地址列表 -->
        <div class="address_section">
            <!-- 空状态 -->
            <van-empty description="暂无收货地址" v-if="addressList.length === 0" />

            <!-- 地址列表 -->
            <div class="address_list" v-else>
                <div class="address_item" v-for="(item, index) in addressList" :key="index">
                    <div class="address_info">
                        <div class="address_header">
                            <span class="name">{{ item.name }}</span>
                            <span class="phone">{{ item.phone }}</span>
                        </div>
                        <div class="address_detail">
                            {{ item.province }}-{{ item.city }}-{{ item.district }}-{{ item.detail }}
                        </div>
                    </div>
                    <div class="address_actions">
                        <div class="action_btn" @click="editAddress(item)">
                            <van-icon name="edit" />
                            <span>编辑</span>
                        </div>
                        <div class="action_btn delete" @click="deleteAddress(item, index)">
                            <van-icon name="delete" />
                            <span>删除</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 地址表单弹窗 -->
        <van-popup v-model="showForm" position="bottom" round :style="{ maxHeight: '80%' }">
            <div class="form_popup">
                <div class="form_title">{{ isEdit ? '编辑地址' : '新增地址' }}</div>

                <div class="form_group">
                    <div class="form_label">收货人</div>
                    <van-field v-model="form.name" placeholder="请输入收货人姓名" />
                </div>

                <div class="form_group">
                    <div class="form_label">手机号</div>
                    <van-field v-model="form.phone" type="tel" placeholder="请输入手机号" />
                </div>

                <div class="form_group">
                    <div class="form_label">所在地区</div>
                    <van-field v-model="form.area" placeholder="请选择省/市/区" readonly @click="showAreaPicker = true" />
                </div>

                <div class="form_group">
                    <div class="form_label">详细地址</div>
                    <van-field v-model="form.detail" type="textarea" placeholder="请输入详细地址" rows="2" />
                </div>

                <div class="form_btns">
                    <div class="btn cancel" @click="showForm = false">取消</div>
                    <div class="btn confirm" @click="saveAddress">保存</div>
                </div>
            </div>
        </van-popup>

        <!-- 地区选择器 -->
        <van-popup v-model="showAreaPicker" position="bottom" round>
            <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showAreaPicker = false" />
        </van-popup>
    </div>
</template>

<script>
/**
 * 收货地址页面组件
 * 管理用户收货地址，支持增删改查和设置默认地址
 */
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Empty, Icon, Popup, Field, Area, Dialog } from 'vant';
import { areaList } from '@vant/area-data';

Vue.use(Empty).use(Icon).use(Popup).use(Field).use(Area).use(Dialog);

export default {
    name: "address",
    /**
     * 组件数据
     * @returns {Object} 数据对象
     * @returns {Array} addressList - 地址列表
     * @returns {boolean} showForm - 是否显示表单弹窗
     * @returns {boolean} showAreaPicker - 是否显示地区选择器
     * @returns {boolean} isEdit - 是否为编辑模式
     * @returns {Object} form - 表单数据
     * @returns {Object} areaList - 地区数据
     * @returns {number|null} editId - 正在编辑的地址ID
     */
    data() {
        return {
            addressList: [],
            showForm: false,
            showAreaPicker: false,
            isEdit: false,
            form: {
                name: '',
                phone: '',
                area: '',
                province: '',
                city: '',
                district: '',
                detail: ''
            },
            areaList: areaList,
            editId: null
        };
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        this.loadData();
    },
    methods: {
        /**
         * 加载地址列表
         * 获取用户所有收货地址
         */
        loadData() {
            Fetch('/address/list').then(r => {
                this.addressList = r.data || [];
            }).catch(() => {
                this.addressList = [];
            });
        },
        /**
         * 重置表单
         * 清空表单数据
         */
        resetForm() {
            this.isEdit = false;
            this.editId = null;
            this.form = {
                name: '',
                phone: '',
                area: '',
                province: '',
                city: '',
                district: '',
                detail: '',
                is_default: false
            };
        },
        /**
         * 编辑地址
         * @param {Object} item - 地址数据
         */
        editAddress(item) {
            this.isEdit = true;
            this.editId = item.id;
            this.form = {
                name: item.name,
                phone: item.phone,
                area: item.province + item.city + item.district,
                province: item.province,
                city: item.city,
                district: item.district,
                detail: item.detail,
                is_default: item.is_default == 1
            };
            this.showForm = true;
        },
        /**
         * 地区选择确认
         * @param {Array} values - 选中的地区值
         */
        onAreaConfirm(values) {
            this.form.province = values[0].name;
            this.form.city = values[1].name;
            this.form.district = values[2].name;
            this.form.area = values[0].name + '-' + values[1].name + '-' + values[2].name;
            this.showAreaPicker = false;
        },
        /**
         * 保存地址
         * 新增或更新地址信息
         */
        saveAddress() {
            // 表单验证
            if (!this.form.name) {
                this.$toast('请输入收货人姓名');
                return;
            }
            if (!this.form.phone) {
                this.$toast('请输入手机号');
                return;
            }
            if (!this.form.area) {
                this.$toast('请选择所在地区');
                return;
            }
            if (!this.form.detail) {
                this.$toast('请输入详细地址');
                return;
            }
            
            const url = this.isEdit ? '/address/update' : '/address/add';

            const params = {
                ...this.form,
                is_default: this.form.is_default ? 1 : 0
            };

            if (this.isEdit) {
                params.id = this.editId;
            }

            Fetch(url, params).then(r => {
                if (r.code === 1) {
                    this.$toast({
                        message: this.isEdit ? '修改成功' : '添加成功',
                        background: '#07c160'
                    });
                    this.showForm = false;
                    this.loadData();
                }
            });
        },
        /**
         * 设置默认地址
         * @param {Object} item - 地址数据
         */
        setDefault(item) {
            if (item.is_default == 1) return;

            Fetch('/user/address_default', {
                id: item.id
            }).then(r => {
                if (r.code === 1) {
                    this.$toast({
                        message: '设置成功',
                        background: '#07c160'
                    });
                    this.loadData();
                }
            });
        },
        /**
         * 删除地址
         * @param {Object} item - 地址数据
         * @param {number} index - 地址索引
         */
        deleteAddress(item, index) {
            Dialog.confirm({
                title: '提示',
                message: '确定要删除该地址吗？'
            }).then(() => {
                Fetch('/user/address_delete', {
                    id: item.id
                }).then(r => {
                    if (r.code === 1) {
                        this.$toast({
                            message: '删除成功',
                            background: '#07c160'
                        });
                        this.addressList.splice(index, 1);
                    }
                });
            }).catch(() => {});
        }
    }
};
</script>

<style lang="less" scoped>
/**
 * 收货地址页面样式
 * 采用卡片式设计，与其他页面保持一致的视觉风格
 */
.address_wrap {
    min-height: 100vh;
    background-color: #f5f5f5;
    padding-bottom: 20px;
}

/* 顶部背景 */
.red_top_bg {
    height: 70px;
    // background-image: url(../images/user/moneybag/bg.png);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .add_btn {
        position: absolute;
        top: 36px;
        right: 15px;
        width: 32px;
        height: 32px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .van-icon {
            font-size: 18px;
            color: #fff;
        }
    }
}

/* 地址列表区域 */
.address_section {
    margin-top: 74px;
    padding: 0 15px;
}

/* 地址列表 */
.address_list {
    .address_item {
        background: #fff;
        border-radius: 12px;
        margin-bottom: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        overflow: hidden;

        .address_info {
            padding: 16px 20px;
            border-bottom: 1px solid #f5f5f5;

            .address_header {
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                .name {
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    margin-right: 12px;
                }

                .phone {
                    font-size: 14px;
                    color: #666;
                }

                .default_tag {
                    margin-left: 10px;
                    padding: 2px 8px;
                    font-size: 11px;
                    color: #ff5252;
                    background: rgba(255, 82, 82, 0.1);
                    border-radius: 4px;
                }
            }

            .address_detail {
                font-size: 14px;
                color: #666;
                line-height: 1.5;
            }
        }

        .address_actions {
            display: flex;
            padding: 12px 20px;

            .action_btn {
                display: flex;
                align-items: center;
                margin-right: 20px;
                cursor: pointer;

                .van-icon {
                    font-size: 16px;
                    color: #999;
                    margin-right: 4px;
                }

                span {
                    font-size: 13px;
                    color: #999;
                }

                &.delete {
                    .van-icon,
                    span {
                        color: #ff5252;
                    }
                }
            }
        }
    }
}

/* 表单弹窗 */
.form_popup {
    padding: 20px;

    .form_title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        text-align: center;
        margin-bottom: 20px;
    }

    .form_group {
        margin-bottom: 16px;

        .form_label {
            font-size: 14px;
            color: #333;
            margin-bottom: 8px;
            font-weight: 500;
        }

        .van-field {
            background: #f5f5f5;
            border-radius: 8px;
            padding: 12px;
        }
    }

    .form_switch {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0;
        margin-bottom: 20px;

        span {
            font-size: 14px;
            color: #333;
        }
    }

    .form_btns {
        display: flex;
        gap: 12px;

        .btn {
            flex: 1;
            height: 44px;
            line-height: 44px;
            text-align: center;
            border-radius: 22px;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;

            &:active {
                transform: scale(0.98);
            }

            &.cancel {
                background: #f5f5f5;
                color: #666;
            }

            &.confirm {
                background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
                color: #fff;
                box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
            }
        }
    }
}
</style>
